// turns text to a url friendly format (slugs)
export const slugify = (text = ''): string =>
	text
		.trim()
		.toLowerCase()
		.replace(/ /g, '-')
		.replace('&', 'and')
		.replace(/[^\w-]+/g, '');

export const unslugify = (text = ''): string => text.trim().replace(/\-/g, ' ');
